// @ts-ignore
import "./index.css";
import React from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import User from "./pages/User";
import Unauthorized from "./pages/Unauthorized";
import ProtectedRoute from "./auth/ProtectedRoute";
import Rounding from "./pages/Rounding";
import Conversion from "./pages/Conversion";
import Multiplication from "./pages/Multiplication";

function AppRouter() {
  const { user } = useAuth();

  function AuthWatcher() {
    const navigate = useNavigate();
    const { logout } = useAuth();
    React.useEffect(() => {
      const onUnauthorized = () => {
        try {
          logout();
        } catch { }
        navigate("/login", { replace: true });
      };
      window.addEventListener("app:unauthorized", onUnauthorized);
      return () => window.removeEventListener("app:unauthorized", onUnauthorized);
    }, [logout, navigate]);
    return null;
  }

  return (
    <BrowserRouter>
      <AuthWatcher />
      {/* Hide the navbar when not signed in */}
      {user && <Navbar />}

      <Routes>
        {/* Public: login only when not signed in */}
        <Route path="/login" element={<Login />} />

        {/* Protect main pages so unauthenticated users see only /login */}
        <Route
          path="/"
          element={
            <ProtectedRoute allowedRoles={["user", "admin"]}>
              <Home />
            </ProtectedRoute>
          }
        />

        <Route
          path="/unauthorized"
          element={
            <ProtectedRoute allowedRoles={["user", "admin"]}>
              <Unauthorized />
            </ProtectedRoute>
          }
        />

        <Route
          path="/user"
          element={
            <ProtectedRoute allowedRoles={["user", "admin"]}>
              <User />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Admin />
            </ProtectedRoute>
          }
        />

        <Route
          path="/rounding"
          element={
            <ProtectedRoute allowedRoles={["user", "admin"]}>
              <Rounding />
            </ProtectedRoute>
          }
        />
        <Route
          path="/conversion"
          element={
            <ProtectedRoute allowedRoles={["user", "admin"]}>
              <Conversion />
            </ProtectedRoute>
          }
        />
        <Route
          path="/multiplication"
          element={
            <ProtectedRoute allowedRoles={["user", "admin"]}>
              <Multiplication />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export function App() {
  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
}

export default App;
